<app-header-user></app-header-user>

<!-- Content -->
<div class="ptb-70">
    <div class="container">
        <div class="tickets-info-box mb-4 shadow-sm rounded-3 p-3 p-md-4">
            <div class="row g-3 align-items-center">
                <div class="col-md-8 d-flex">
                    <div class="icon-wrap me-3">
                        <i class="bx bx-file-find"></i>
                    </div>
                    <div>
                        <h5 class="mb-1">Bilete de trimitere emise</h5>
                        <p class="mb-0 small text-muted">
                            Dacă aveți documente medicale (rezultate analize,
                            bilete de ieșire din spital etc.) care trebuie să
                            ajungă la medicul de familie / specialist, le puteți
                            încărca în
                            <strong>Modulul Rezultate</strong> →
                            <strong>Încărcare document</strong>.
                        </p>
                    </div>
                </div>
            </div>
        </div>
        <!-- Formular bilet -->
        <div class="row justify-content-center">
            <div class="col-xxl-10 col-lg-10 col-md-12">
                <div class="progBox">
                    <h3 class="section-title text-start mb-4">
                        <i class="bx bx-plus-medical"></i> Adaugă bilet nou
                    </h3>

                    <form (ngSubmit)="addTicket()">
                        <div class="row g-3">
                            <!-- Serie -->
                            <div class="col-lg-6">
                                <div class="form-group">
                                    <label for="batch">
                                        Serie <span class="text-danger">*</span>
                                    </label>
                                    <input
                                        type="text"
                                        id="batch"
                                        class="form-control"
                                        placeholder="Ex: AB12CD"
                                        [(ngModel)]="ticket.batch"
                                        name="batch"
                                        (input)="onInput2($event)"
                                    />
                                </div>
                            </div>

                            <!-- Număr -->
                            <div class="col-lg-6">
                                <div class="form-group">
                                    <label for="number">
                                        Număr <span class="text-danger">*</span>
                                    </label>
                                    <input
                                        type="number"
                                        id="number"
                                        class="form-control"
                                        placeholder="Ex: 1234567"
                                        [(ngModel)]="ticket.number"
                                        name="number"
                                        (input)="onInput($event)"
                                    />
                                </div>
                            </div>

                            <!-- Tip bilet -->
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label>
                                        Tip bilet
                                        <span class="text-danger">*</span>
                                    </label>
                                    <ng-select
                                        class="custom-ng-select"
                                        [items]="types"
                                        bindLabel="name"
                                        bindValue="value"
                                        placeholder="Selectează tipul (ACUT, SUBACUT, CRONIC)"
                                        [(ngModel)]="ticket.diagnosticType"
                                        name="type"
                                    >
                                    </ng-select>
                                </div>
                            </div>

                            <!-- Casă de sănătate -->
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label>
                                        Casă de sănătate
                                        <span class="text-danger">*</span>
                                    </label>
                                    <ng-select
                                        class="custom-ng-select"
                                        [items]="healthOrganizations"
                                        bindLabel="label"
                                        bindValue="label"
                                        placeholder="Selectează casa de sănătate"
                                        [(ngModel)]="ticket.healthOrganisation"
                                        name="healthOrganization"
                                    >
                                    </ng-select>
                                </div>
                            </div>

                            <!-- Specialitate -->
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label>
                                        Specialitate
                                        <span class="text-danger">*</span>
                                    </label>
                                    <ng-select
                                        class="custom-ng-select"
                                        [items]="specialties"
                                        bindLabel="name"
                                        bindValue="name"
                                        placeholder="Selectează specialitatea"
                                        [(ngModel)]="
                                            ticket.senderSpecialization
                                        "
                                        name="specialty"
                                    >
                                    </ng-select>
                                </div>
                            </div>

                            <!-- Doctor -->
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label for="doctor">
                                        Doctor
                                        <span class="text-danger">*</span>
                                    </label>
                                    <input
                                        type="text"
                                        id="doctor"
                                        class="form-control"
                                        placeholder="Ex: Dr. Popescu Ion"
                                        [(ngModel)]="ticket.senderDoctor"
                                        name="doctor"
                                    />
                                </div>
                            </div>
                        </div>

                        <!-- DUPĂ câmpul "Doctor", adaugă acest input pentru fișier -->
                        <div class="col-12">
                            <div class="form-group">
                                <label for="file">
                                    Fișier atașat
                                    <span class="text-muted">(opțional)</span>
                                </label>
                                <input
                                    type="file"
                                    id="file"
                                    class="form-control"
                                    (change)="onFileSelected($event)"
                                    accept=".pdf,.jpg,.jpeg,.png,.doc,.docx"
                                />
                                <small class="form-text text-muted">
                                    Formate acceptate: PDF, JPG, PNG, DOC, DOCX
                                    (max 5MB)
                                </small>

                                <!-- Preview nume fișier selectat -->
                                <div *ngIf="selectedFile" class="mt-2">
                                    <span class="badge bg-info">
                                        <i class="bx bx-file"></i>
                                        {{ selectedFile.name }} ({{
                                            (selectedFile.size / 1024).toFixed(
                                                2
                                            )
                                        }}
                                        KB)
                                    </span>
                                    <button
                                        type="button"
                                        class="btn btn-sm btn-link text-danger"
                                        (click)="removeFile()"
                                    >
                                        <i class="bx bx-x"></i> Șterge
                                    </button>
                                </div>
                            </div>
                        </div>

                        <!-- Butonul de submit rămâne la fel -->
                        <div class="button-container mt-4">
                            <button
                                type="button"
                                class="default-btn small-button"
                                [disabled]="!isDisabled() || isSubmitting"
                                (click)="addTicket()"
                            >
                                <i class="bx bx-plus-circle"></i>
                                <span>{{
                                    isSubmitting
                                        ? "Se adaugă..."
                                        : "Adaugă bilet"
                                }}</span>
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
</div>
